import { environment } from '../environments/environment';
import { ApplicationConfig, inject, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DemandeAffiliationConsultantService } from './_shared/services/demande-affiliation/demande-affiliation-consultant.service';
import { AuthService } from '@lib/auth/auth.service';
import { ApereoAuthService } from '@lib/auth/apereo-auth.service';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { GedService } from '@lib/ged/ged.service';
import { setContext } from '@apollo/client/link/context';
import { GraphqlDemandeAffiliationConsultantService } from './_shared/services/demande-affiliation/graphql/graphql-demande-affiliation-consultant.service';
import { AzureGedService } from '@lib/ged/azure-ged.service';
import {
  COMMON_ENVIRONMENT,
  CommonEnvironment,
} from '@lib/core/environment/common-environment';
import { APP_AUDIENCE } from '@lib/core/environment/app-audience';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: false }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withFetch()),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const authService = inject(AuthService);

      const authLink = setContext(async (_, { headers }) => {
        const token = await authService.getToken();
        return {
          headers: {
            ...headers,
            Authorization: token ? `Bearer ${token}` : '',
          },
        };
      });

      return {
        link: ApolloLink.from([
          authLink,
          httpLink.create({ uri: environment.graphqlUri }),
        ]),
        cache: new InMemoryCache(),
      };
    }),
    {
      provide: COMMON_ENVIRONMENT,
      useValue: environment as CommonEnvironment,
    },
    {
      provide: DemandeAffiliationConsultantService,
      useClass: GraphqlDemandeAffiliationConsultantService,
    },
    { provide: AuthService, useClass: ApereoAuthService },
    ...environment.developmentProviders,
    { provide: GedService, useClass: AzureGedService },
    {
      provide: APP_AUDIENCE,
      useValue: 'consultant',
    },
  ],
};
